export const UPDATE_STEP = "corp-quote/UPDATE_STEP";

//Fetch questions
export const FETCHING_QUESTIONS = "corp-quote/FETCHING_QUESTIONS";
export const FETCH_QUESTIONS = "corp-quote/FETCH_QUESTIONS";
export const FETCH_QUESTIONS_SUCCESS = "corp-quote/FETCH_QUESTIONS_SUCCESS";
export const SET_QUESTION_ANSWER = "corp-quote/SET_QUESTION_ANSWER";
export const CLEAR_QUESTION_ANSWERS = "corp-quote/CLEAR_QUESTION_ANSWERS";

export const SET_CQC_COUNTRY = "corp-quote/CREATE_SET_COUNTRY";
export const SET_CQC_COSTCENTER = "corp-quote/CREATE_SET_COSTCENTER";
export const SET_CQC_RESCOSTCENTER = "corp-quote/CREATE_SET_RESCOSTCENTER";

//Fetch VEHICLES
export const FETCHING_VEHICLES = "corp-quote/FETCHING_VEHICLES";
export const FETCH_VEHICLES = "corp-quote/FETCH_VEHICLES";
export const FETCH_VEHICLES_SUCCESS = "corp-quote/FETCH_VEHICLES_SUCCESS";
export const FETCH_VEHICLES_ERROR = "corp-quote/FETCH_VEHICLES_ERROR";

//Fetch options
export const FETCHING_OPTIONS = "corp-quote/FETCHING_OPTIONS";
export const FETCH_OPTIONS = "corp-quote/FETCH_OPTIONS";
export const FETCH_OPTIONS_SUCCESS = "corp-quote/FETCH_OPTIONS_SUCCESS";

//Select vehicle
export const SELECT_VEHICLE = "corp-quote/SELECT_VEHICLE";

//Select Colour
export const SELECT_COLOUR = "corp-quote/SELECT_COLOUR";

//Select/Deselect Extra
export const SELECT_EXTRA = "corp-quote/SELECT_EXTRA";
export const DESELECT_EXTRA = "corp-quote/DESELECT_EXTRA";


//Delivery Details
export const SET_DELIVERY_DETAILS = "corp-quote/SET_DELIVERY_DETAILS";

//Fetch address
export const FETCHING_ADDRESSES = "corp-quote/FETCHING_ADDRESSES";
export const FETCH_ADDRESSES = "corp-quote/FETCH_ADDRESSES";
export const FETCH_ADDRESSES_SUCCESS = "corp-quote/FETCH_ADDRESSES_SUCCESS";

// Summary
export const FETCHING_QUOTE_SUMMARY = "corp-quote/FETCHING_QUOTE_SUMMARY";
export const FETCH_QUOTE_SUMMARY_SUCCESS = "corp-quote/FETCH_QUOTE_SUMMARY_SUCCESS";
export const FETCH_QUOTE_SUMMARY="corp-quote/FETCH_QUOTE_SUMMARY"

export const EXPORT_QUOTE = "corp-quote/EXPORT_QUOTE";
export const EXPORTING_QUOTE = "corp-quote/EXPORTING_QUOTE";
export const EXPORT_QUOTE_SUCCESS = "corp-quote/EXPORT_QUOTE_SUCCESS";
export const EXPORT_QUOTE_FAILED = "corp-quote/EXPORT_QUOTE_FAILED";

export const SUBMIT_QUOTE = "corp-quote/SUBMIT_QUOTE";
export const SUBMITTING_QUOTE = "corp-quote/SUBMITTING_QUOTE";
export const SUBMIT_QUOTE_SUCCESS = "corp-quote/SUBMIT_QUOTE_SUCCESS";
export const SUBMIT_QUOTE_FAILED = "corp-quote/SUBMIT_QUOTE_FAILED";

export const UPDATE_QUOTE = "corp-quote/UPDATE_QUOTE";
export const UPDATING_QUOTE = "corp-quote/UPDATING_QUOTE";
export const UPDATE_QUOTE_SUCCESS = "corp-quote/UPDATE_QUOTE_SUCCESS";
export const UPDATE_QUOTE_FAILED = "corp-quote/UPDATE_QUOTE_FAILED";

// Estimated cost
export const SET_ESTIMATED_COST = "corp-quote/SET_ESTIMATED_COST";

// Set QuoteId
export const SET_QUOTE_ID = "corp-quote/SET_QUOTE_ID";

// Set LeaseDetails
export const SET_LEASE_DETAILS = "corp-quote/SET_LEASE_DETAILS";


export type Action =
  { type: UPDATE_STEP, STEP: Number }
    | { type: SET_CQC_COUNTRY, value: String }
    | { type: SET_CQC_COSTCENTER, value: String }
    | { type: SET_CQC_RESCOSTCENTER, value: String }
    | { type: FETCHING_QUESTIONS }
    | { type: FETCH_QUESTIONS, data: Array<Object> }
    | { type: FETCH_QUESTIONS_SUCCESS, data: Array<Object> }
    | { type: SET_QUESTION_ANSWER, qIndex: Number, aIndex: Number }
    | { type: CLEAR_QUESTION_ANSWERS }
    | { type: FETCHING_VEHICLES }
    | { type: FETCH_VEHICLES, data: Object }
    | { type: FETCH_VEHICLES_SUCCESS, data: Object }
    | { type: FETCH_VEHICLES_ERROR, data: Object }
    | { type: FETCHING_OPTIONS }
    | { type: FETCH_OPTIONS, data: Array<Object> }
    | { type: FETCH_OPTIONS_SUCCESS, data: Array<Object> }
    | { type: SELECT_COLOUR }
    | { type: SELECT_EXTRA, code: String }
    | { type: DESELECT_EXTRA, code: String }
    | { type: SET_DELIVERY_DETAILS}
    | { type: FETCHING_ADDRESSES }
    | { type: FETCH_ADDRESSES, data: Array<Object> }
    | { type: FETCH_ADDRESSES_SUCCESS, data: Array<Object> }
    | { type: FETCHING_QUOTE_SUMMARY }
    | { type: FETCH_QUOTE_SUMMARY_SUCCESS, summary: Object }
    | { type: SET_ESTIMATED_COST }
    | { type: SET_QUOTE_ID }
    | { type: SET_LEASE_DETAILS}



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/action-types.js